import { baths } from "../shared/listing";
import LabelValue from "../search/result/label-value";
import Price from "../search/result/price";
import PropTypes from "prop-types";
import React from "react";
import Separate from "../search/result/separate";
import Slider from "../search/result/mini-slideshow/";

const PhotoResult = ({ listing }) => {
  const listingLink = listing.listingLink
    ? listing.listingLink
    : "/" +
      listing.regionUrlPart +
      "/" +
      listing.listingType +
      "s" +
      "/" +
      listing.identifier;
  const maxFinancing =
    listing.maxFinancing === 0 ? (
      "No Financing Allowed"
    ) : (
      <LabelValue
        label="Max Financing"
        value={listing.maxFinancing}
        suffix="%"
      />
    );
  return (
    <li
      className={
        "list-element grid-element col-md-4 col-sm-4 col-xs-8 col-xxs-16"
      }
      role="group"
      aria-label="listing"
    >
      <Slider
        listing={listing}
        link={listingLink}
        sizes="(min-width: 561px) 45vw, (min-width: 768px) 23vw, (min-width: 1100px) 256, 90vw"
      />
      <div className="grid-listinfo">
        <a className="listing-title" href={listingLink}>
          <h3>{listing.title}</h3>
        </a>
        <div className="by-line">{listing.cityStateCountry}</div>
        <Separate
          items={[
            ["Bed", listing.totalBedrooms],
            ["Baths", baths(listing)],
            [
              "Int",
              listing.interiorSize
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
              "sq. ft",
            ],
          ]}
        />
        <Separate items={[["EH RR #", listing.rentalRegistration]]} />
        <p className="info-2">
          <LabelValue label="Listing Courtesy of" value={listing.courtesyOf} />
        </p>
        {listing.regionUrlPart === "nyc" ? (
          <p className="info-2">{maxFinancing}</p>
        ) : (
          ""
        )}

        <p className="info-2 float-left">
          <Price listing={listing} />
        </p>
        <div className="clearfix">&nbsp;</div>
        <p></p>
      </div>

      <div className="clearfix">&nbsp;</div>
    </li>
  );
};

PhotoResult.propTypes = {
  listing: PropTypes.object.isRequired,
};

export default PhotoResult;



// WEBPACK FOOTER //
// ./src/components/search/photo-result.jsx